/* eslint-disable camelcase */
import React from 'react';
import { PropTypes } from 'prop-types';
import { formatNumericDate } from '../../../utils/dates';

const Visit = ({ visit }) => {
  const {
    site_name, date, completed, purpose,
  } = visit;

  return (
    <a href={`sites/${visit.site_id}/visits/${visit.id}`} className="flex items-center py-2 px-4 text-black gap-4 rounded-lg bg-vamos-v-light-gray mb-2 max-w-none hover:no-underline hover:text-black hover:bg-vamos-light-gray">
      <h4 className="flex items-center text-base font-medium gap-2 text-black min-w-[72px]">
        {formatNumericDate(date)}
      </h4>
      <h3 className="flex items-center flex-1 min-w-0 text-base font-bold m-0 gap-3">
        <span className="min-w-0 truncate">
          {purpose && <span className="font-semibold">{purpose}</span>}
          <span className="text-sm font-normal text-vamos-grey-70 ml-3">{`@ ${site_name}`}</span>
        </span>
        <span
          className={`flex-none text-sm font-semibold whitespace-nowrap ${
            completed ? 'text-vamos-green1' : 'text-vamos-orange'
          }`}
        >
          {completed ? 'Completed' : 'Attempted'}
        </span>
      </h3>
    </a>
  );
};

export default Visit;

Visit.propTypes = {
  visit: PropTypes.object.isRequired,
};
